import { render } from "./AddNetworkOffering.vue?vue&type=template&id=dec970ba&scoped=true"
import script from "./AddNetworkOffering.vue?vue&type=script&lang=js"
export * from "./AddNetworkOffering.vue?vue&type=script&lang=js"

import "./AddNetworkOffering.vue?vue&type=style&index=0&id=dec970ba&scoped=true&lang=scss"

import exportComponent from "/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dec970ba"]])

export default __exports__